import { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import parse from "html-react-parser";

// Components
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../video.module.scss";

// Constants
const arrowForwardIconSrc =
    require("../../../assets/icons/arrow-forward-dark.svg").default;
const envelopeIconSrc =
    require("../../../assets/icons/envelope-dark.svg").default;
const linkedinIconSrc =
    require("../../../assets/icons/linkedin-dark.svg").default;
const twitterIconSrc =
    require("../../../assets/icons/twitter-dark.svg").default;

const VideoHeader = (props) => {
    const { copyLinkToClipboard, tooltipText, video } = props;
    const { conference, description, title } = video || {};

    /**
     * useMemo
     */

    const encodedShareDescription = useMemo(
        () => encodeURIComponent(`Watch ${video?.title} on Symphony Innovate`),
        [video]
    );

    /**
     * End Hooks
     */

    function renderTooltip() {
        return <Tooltip id="share-tooltip">{tooltipText}</Tooltip>;
    }

    return (
        <div className={styles.video}>
            <Section classes={styles.headerContainer}>
                <div className={styles.title}>
                      {title && <h1>{parse(video.title)}</h1>}
                </div>
                <div className={styles.subheader}>
                    <span>{conference}</span>
                </div>
                <div className={styles.row}>
                    <p className={styles.description}>
                        {parse(description || "")}
                    </p>
                    <div className={styles.icons}>
                        <div
                            className={styles.icon}
                            onClick={copyLinkToClipboard}
                        >
                            <OverlayTrigger
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip()}
                                placement="top"
                            >
                                <img
                                    alt="Forward arrow icon"
                                    src={arrowForwardIconSrc}
                                />
                            </OverlayTrigger>
                        </div>
                        <a
                            className={styles.icon}
                            href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
                            rel="nofollow noreferrer"
                            target="_blank"
                        >
                            <img alt="Linkedin icon" src={linkedinIconSrc} />
                        </a>
                        <a
                            className={styles.icon}
                            href={`https://twitter.com/intent/tweet?url=${window.location.href}&text=${encodedShareDescription}`}
                            rel="nofollow noreferrer"
                            target="_blank"
                        >
                            <img alt="Twitter icon" src={twitterIconSrc} />
                        </a>
                        <a
                            className={styles.icon}
                            href={`mailto:?body=${encodedShareDescription}&subject=${video?.title}`}
                            rel="nofollow noreferrer"
                            target="_blank"
                        >
                            <img alt="Envelope icon" src={envelopeIconSrc} />
                        </a>
                    </div>
                </div>
            </Section>
        </div>
    );
};

export default VideoHeader;
